import { Component, input } from "@angular/core";
import {  IconComponent } from "@husbanken/designsystem-angular-core";
import { Tiltak } from "../../../../models/oppsummering.model";
import { Router } from "@angular/router";

@Component({
  selector: "bko-tiltak-card",
  imports: [IconComponent],
  templateUrl: "./tiltak-button.html",
  styleUrl: "./tiltak-button.scss",
})
export class TiltakButton {
  tiltak = input.required<Tiltak>();
  besvarelseId = input<string>();

  constructor(private router: Router) {}

  protected tilTiltakBeskrivelse() {
    this.router.navigate(["/tiltak-beskrivelse", this.tiltak().id], {
      queryParams: this.besvarelseId() ? { besvarelseId: this.besvarelseId() } : {},
    });
  }
}
